import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiCountry, ApiLocality, ApiPlace, ApiRegion } from '@app/packages/api/v2/types/entities'

export class ApiPlaceFabricator extends ApiFabricator<ApiPlace> {
  protected getBase = (): ApiPlace => ({
    type: 'places',
    id: ApiFabricator.getId('places'),
    attributes: {
      address: 'Москва, ул. Ленина, 1',
      latitude: 55.755814,
      longitude: 37.617635,
    },
    relationships: {
      country: { meta: { included: false } },
      region: { meta: { included: false } },
      locality: { meta: { included: false } },
    },
  })

  bindCountry(country: ApiCountry) {
    return this.setRelationship('country', { data: { id: country.id, type: 'countries' } })
  }

  bindRegion(region: ApiRegion) {
    return this.setRelationship('region', { data: { id: region.id, type: 'regions' } })
  }

  bindLocality(locality: ApiLocality) {
    return this.setRelationship('locality', { data: { id: locality.id, type: 'localities' } })
  }
}
